import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import {router} from './routes';
import {RouterProvider} from "react-router-dom";
import "./styles/index.scss";
import BackToTopComponent from './components/BackToTopComponent/BackToTopComponent';
import {QueryClient, QueryClientProvider} from 'react-query';
import LoaderComponent from './components/LoaderComponent/LoaderComponent';
import AppContextProvider from './contexts/appContext';
import "./utils/Global.js"
import 'bootstrap-italia';
import globals from "./config/appconfig";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

const App = () => {

    useEffect(()=>{
        var _paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
            var u="https://ingestion.webanalytics.italia.it/";
            _paq.push(['setTrackerUrl', u+'matomo.php']);
            _paq.push(['setSiteId', globals["site-id"]]);
            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
        })();
    },[])

    return (
        <div>
            <RouterProvider router={ router } />
            <BackToTopComponent></BackToTopComponent>
            <LoaderComponent></LoaderComponent>
        </div>
    );
};

root.render(
    <QueryClientProvider client={ queryClient }>
        <AppContextProvider>
            <App />
        </AppContextProvider>
    </QueryClientProvider>
);

